export default __webpack_public_path__ + "static/media/nav-arrow.12e61ddf.svg";